<template>
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
    <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
      {{ title }}
    </h3>
    <dl class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
      <slot />
    </dl>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true }
})
</script>
